import { useEffect, useMemo } from 'react'
import { useResponsive } from 'ahooks'
import SideBar from './widget/Sidebar/index'
import Content from './widget/content'
import Instruct from './widget/Instruct'
import {
  globalState,
  chatSideBarAction,
  configAction,
  assistantAction,
  chatSideBarState,
  ChatType,
} from '@/store'
import reportAction from '@/utils/statistic'
import { useSnapshot } from 'valtio'
import AssContent from '@/pages/assistant/playground/widget/content'
import AiContent from '@/pages/chat/widget/AiChat'
import GuideModal from './widget/GuideModal'

export default function Chat() {
  const responsive = useResponsive()
  const { chatType } = useSnapshot(chatSideBarState)

  useEffect(() => {
    assistantAction.updateSubmittable(true)
    chatSideBarAction.getHistoryRecord()
    configAction.getPrompt()
    configAction.getBanner()
    assistantAction.getRecommand()
    assistantAction.getFeatureList()
    if (globalState.userInfo.id) {
      reportAction({
        action: 'chat_page',
        user_id: globalState.userInfo.id,
      })
    }
  }, [])

  const content = useMemo(() => {
    if (chatType === ChatType.chat) {
      return <Content />
    } else if (chatType === ChatType.agent) {
      return <AssContent className={'h-full'} isShowClean={false} />
    } else if (chatType === ChatType.aiAgent) {
      return <AiContent />
    }
    return <Content />
  }, [chatType])

  return (
    <div className="flex-1 flex flex-row overflow-hidden bg-white">
      {responsive.sm && <SideBar />}
      {content}
      {responsive.lg && chatType === ChatType.chat && <Instruct />}
      <GuideModal />
    </div>
  )
}
